import LegalPage from "@/components/feature/LegalPage";

export default function Disclaimer() {
  return (
    <LegalPage
      title="Medical Disclaimer"
      subtitle="Important information about the content on this website."
      crumbs={[{ label: "Home", to: "/" }, { label: "Disclaimer" }]}
      sections={[
        {
          heading: "General information only",
          paragraphs: [
            "The information on this website is provided for general health information and educational purposes only. It does not replace consultation, diagnosis or treatment by a qualified healthcare professional.",
          ],
        },
        {
          heading: "No doctor-patient relationship",
          paragraphs: [
            "Using this website or submitting a form does not create a doctor-patient relationship. A relationship is established only after a consultation with our specialist.",
          ],
        },
        {
          heading: "Individual results vary",
          paragraphs: [
            "Orthopaedic and spine conditions are highly individual. Treatment options and outcomes depend on each patient's circumstances. No specific outcome is guaranteed, and any treatment decision should be made together with your specialist.",
          ],
        },
        {
          heading: "Seek emergency care when needed",
          paragraphs: [
            "If you have severe pain, loss of bladder or bowel control, progressive weakness, or a serious injury, seek immediate medical attention or emergency care rather than relying on this website.",
          ],
        },
      ]}
    />
  );
}